import React from "react";
import "../css/PlanItemBase.css";

const PlanItemBase = ({ icon, time, name, children }) => {
  return (
    <div className="plan-item-base">
      <div className="item-header">
        <div className="icon-container">{icon}</div>
        <div className="item-main-info">
          <div className="item-time">{time}</div>
          <h3 className="item-name">{name}</h3>
        </div>
      </div>
      {children && <div className="item-children">{children}</div>}
    </div>
  );
};

export default PlanItemBase;
